import Vue from 'vue'
import apiUsers from '@/api/user'

import {USER_INIT_USERDATA, USER_REFRESH_USERDATA, USER_REFRESH_NOTIFICATIONS} from '../mutations'

const state = {
    userdata: {
        id: '',
        username: '',
        lastname: '',
        firstname: '',
        email: ''
    },
    roles: {
        admin: false,
        franchisee: false
    },
    notifications: []
}

const getters = {
    isAdmin (state) {
        return state.roles.admin
    },
    isFranchisee (state) {
        return state.roles.franchisee
    }
}

const mutations = {
    [USER_INIT_USERDATA] (state, id) {
        state.userdata.id = id
    },
    [USER_REFRESH_USERDATA] (state, userdata) {
        if (state.userdata.username !== userdata.username) state.userdata.username = userdata.username
        if (state.userdata.lastname !== userdata.lastname) state.userdata.lastname = userdata.lastname
        if (state.userdata.firstname !== userdata.firstname) state.userdata.firstname = userdata.firstname
        if (state.userdata.email !== userdata.email) state.userdata.email = userdata.email

        if (state.roles.admin !== userdata.admin) state.roles.admin = userdata.admin
        if (state.roles.franchisee !== userdata.franchisee) state.roles.franchisee = userdata.franchisee

        let auth = Object.assign({}, Vue.auth.user())
        auth.roles = []

        if (state.roles.admin) {
            auth.roles.push('admin')
        }
        if (state.roles.franchisee) {
            auth.roles.push('franchisee')
        }
        Vue.auth.user(auth)
    },
    [USER_REFRESH_NOTIFICATIONS] (state, notifications) {
        state.notifications = notifications
    }
}

const actions = {
    initUserdata ({ commit }, id) {
        commit(USER_INIT_USERDATA, id)
    },
    refreshUserdata ({ commit }) {
        apiUsers.loadUserdata(userdata => {
            commit(USER_REFRESH_USERDATA, userdata)
        })
    },
    refreshNotifications ({ commit }) {
        apiUsers.loadNotifications(notifications => {
            commit(USER_REFRESH_NOTIFICATIONS, notifications)
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js